module.exports = __webpack_public_path__ + "28783e96c42379ccebe24ef8b81d5361.pdf";